import * as React from 'react';

import {
  Colors,
} from '@bluecurrent/web-component-lib';

export default function Separator() {
  return (
    <div
      style={{
        height: 'calc(100% - 80px)',
        width: 'calc(100% + 15px)',
        position: 'absolute',
        top: 20,
        left: -15,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        zIndex: 0,
      }}
    >
      {
        [...Array(5)].map((item, index) => (
          <div
            key={index} // eslint-disable-line react/no-array-index-key
            style={{
              height: index === 4 ? 0 : 4,
              width: '100%',
              position: 'relative',
            }}
          >
            <div
              style={{
                width: '100%',
                height: 4,
                backgroundColor: index === 4 ? Colors.MEDIUM_GREY : Colors.MEDIUM_WHITE,
                position: 'absolute',
              }}
            />
          </div>
        ))
      }
    </div>
  );
}
